import React from "react";
import { useNavigate } from "react-router-dom";

function Navbar({ current }: any) {
  // console.log("current", current);
  const navigate = useNavigate();
  return (
    <nav className="navbar">
      <div
        onClick={() => {
          navigate(`/`);
        }}
      >
        <div className={`tab-btn ${current === "home" ? "active" : ""}`}>
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.9"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20 18.9999V10.6078C20 10.2998 19.858 10.0089 19.6151 9.8194L13.1151 4.74819C12.7536 4.4661 12.2464 4.4661 11.8849 4.74819L5.38488 9.8194C5.14199 10.0089 5 10.2998 5 10.6078V18.9999C5 19.5522 5.44772 19.9999 6 19.9999H19C19.5523 19.9999 20 19.5522 20 18.9999ZM4.76975 9.03097C4.28398 9.40996 4 9.9917 4 10.6078V18.9999C4 20.1045 4.89543 20.9999 6 20.9999H19C20.1046 20.9999 21 20.1045 21 18.9999V10.6078C21 9.9917 20.716 9.40996 20.2302 9.03097L13.7302 3.95976C13.0071 3.39558 11.9929 3.39557 11.2698 3.95976L4.76975 9.03097Z"
              fill="#848B91"
            />
          </svg>
          <span>홈</span>
        </div>
      </div>
      <div
        onClick={() => {
          navigate(`/brandstory`);
        }}
      >
        <div className={`tab-btn ${current === "contents" ? "active" : ""}`}>
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.59011 4.5C4.9914 4.5 4.5 4.98896 4.5 5.60714V17.8571C4.5 18.7646 5.23522 19.5 6.12014 19.5H18.6495C18.4538 19.1801 18.341 18.8042 18.341 18.4036V7.18929H18.341V5.60714C18.341 4.98896 17.8496 4.5 17.2509 4.5H5.59011ZM22.5 18.4036C22.5 19.5355 21.5993 20.4708 20.4735 20.4993V20.5H20.4205H6.12014C4.67291 20.5 3.5 19.3068 3.5 17.8571V5.60714C3.5 4.44675 4.4291 3.5 5.59011 3.5H17.2509C18.4119 3.5 19.341 4.44675 19.341 5.60714V7.18929H20.9399C21.8041 7.18929 22.5 7.90032 22.5 8.76071V18.4036ZM21.5 18.4036C21.5 19.011 21.0086 19.5 20.4205 19.5C19.8324 19.5 19.341 19.011 19.341 18.4036V8.18929H20.9399C21.2418 8.18929 21.5 8.44254 21.5 8.76071V18.4036ZM8.01215 8.51104C8.01215 8.47629 8.02356 8.45304 8.03225 8.44139H9.99401C10.0027 8.45304 10.0141 8.47629 10.0141 8.51104V10.6724C10.0141 10.7071 10.0027 10.7304 9.99401 10.742H8.03225C8.02356 10.7304 8.01215 10.7071 8.01215 10.6724V8.51104ZM8.00843 7.5C7.38493 7.5 7 8.01921 7 8.51104V10.6724C7 11.1642 7.38493 11.6834 8.00843 11.6834H10.0178C10.6413 11.6834 11.0263 11.1642 11.0263 10.6724V8.51104C11.0263 8.01921 10.6413 7.5 10.0178 7.5H8.00843ZM11.9961 8.56974C11.9961 8.29469 12.2214 8.07172 12.4994 8.07172H15.4969C15.7748 8.07172 16.0001 8.29469 16.0001 8.56974C16.0001 8.8448 15.7748 9.06777 15.4969 9.06777H12.4994C12.2214 9.06777 11.9961 8.8448 11.9961 8.56974ZM12.4994 10.3586C12.2214 10.3586 11.9961 10.5816 11.9961 10.8567C11.9961 11.1317 12.2214 11.3547 12.4994 11.3547H15.4969C15.7748 11.3547 16.0001 11.1317 16.0001 10.8567C16.0001 10.5816 15.7748 10.3586 15.4969 10.3586H12.4994ZM7 13.7151C7 13.4401 7.22533 13.2171 7.50328 13.2171H15.4966C15.7745 13.2171 15.9998 13.4401 15.9998 13.7151C15.9998 13.9902 15.7745 14.2132 15.4966 14.2132H7.50328C7.22533 14.2132 7 13.9902 7 13.7151ZM7.50328 15.504C7.22533 15.504 7 15.7269 7 16.002C7 16.277 7.22533 16.5 7.50328 16.5H15.4966C15.7745 16.5 15.9998 16.277 15.9998 16.002C15.9998 15.7269 15.7745 15.504 15.4966 15.504H7.50328Z"
              fill="#848B91"
            />
          </svg>
          <span>콘텐츠</span>
        </div>
      </div>
      <div
        onClick={() => {
          navigate(`/request`);
        }}
      >
        <div className="tab-btn request">
          <div className="request-btn">
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.5 6.23155H13.5C12.4313 6.23155 11.505 6.83214 11.0499 7.70942H21.9501C21.495 6.83214 20.5687 6.23155 19.5 6.23155ZM23.3008 7.70942C22.7759 6.13602 21.2726 5 19.5 5H13.5C11.7274 5 10.2241 6.13602 9.69919 7.70942L9.69363 7.72619H8.25C6.17893 7.72619 4.5 9.38035 4.5 11.4208V22.3053C4.5 24.3458 6.17893 26 8.25 26H24.75C26.8211 26 28.5 24.3458 28.5 22.3053V11.4209C28.5 9.38035 26.8211 7.72619 24.75 7.72619H23.3064L23.3008 7.70942ZM24.75 8.95775H8.25C6.86929 8.95775 5.75 10.0605 5.75 11.4208V22.3053C5.75 23.6657 6.86929 24.7684 8.25 24.7684H24.75C26.1307 24.7684 27.25 23.6657 27.25 22.3053V11.4209C27.25 10.0605 26.1307 8.95775 24.75 8.95775ZM20.7883 16.8631C20.7883 19.216 18.8629 21.1137 16.4999 21.1137C14.1369 21.1137 12.2114 19.216 12.2114 16.8631C12.2114 14.5101 14.1369 12.6125 16.4999 12.6125C18.8629 12.6125 20.7883 14.5101 20.7883 16.8631ZM22.0383 16.8631C22.0383 19.8908 19.5587 22.3452 16.4999 22.3452C13.4411 22.3452 10.9614 19.8908 10.9614 16.8631C10.9614 13.8354 13.4411 11.3809 16.4999 11.3809C19.5587 11.3809 22.0383 13.8354 22.0383 16.8631ZM25.2691 12.0662C25.2691 12.697 24.7525 13.2083 24.1153 13.2083C23.478 13.2083 22.9614 12.697 22.9614 12.0662C22.9614 11.4354 23.478 10.9241 24.1153 10.9241C24.7525 10.9241 25.2691 11.4354 25.2691 12.0662Z"
                fill="white"
              />
            </svg>
          </div>
          <span>견적의뢰</span>
        </div>
      </div>
      <div
        onClick={() => {
          navigate(`/mypage`);
        }}
      >
        <div className={`tab-btn ${current === "mypage" ? "active" : ""}`}>
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.8715 15.1135C20.2762 14.1565 20.5 13.1044 20.5 12C20.5 7.58172 16.9183 4 12.5 4C8.08172 4 4.5 7.58172 4.5 12C4.5 13.1045 4.72385 14.1568 5.12865 15.1139C6.68555 13.3372 9.27105 12 12.5002 12C15.7292 12 18.3146 13.3371 19.8715 15.1135ZM19.3786 16.0871C18.063 14.3886 15.6494 13 12.5002 13C9.35083 13 6.93716 14.3888 5.62157 16.0874C7.01792 18.432 9.57675 20 12.5002 20C12.5224 20 12.5445 19.9999 12.5667 19.9997C15.4639 19.9761 17.994 18.4124 19.3786 16.0871ZM20.554 16.021C19.0774 18.973 16.0254 21 12.5 21C7.52944 21 3.5 16.9706 3.5 12C3.5 7.02944 7.52944 3 12.5 3C17.4706 3 21.5 7.02944 21.5 12C21.5 13.4452 21.1594 14.8108 20.554 16.021ZM12.4998 10.1C13.4387 10.1 14.1998 9.3389 14.1998 8.40001C14.1998 7.46113 13.4387 6.70001 12.4998 6.70001C11.5609 6.70001 10.7998 7.46113 10.7998 8.40001C10.7998 9.3389 11.5609 10.1 12.4998 10.1ZM12.4998 11.1C13.991 11.1 15.1998 9.89118 15.1998 8.40001C15.1998 6.90884 13.991 5.70001 12.4998 5.70001C11.0086 5.70001 9.7998 6.90884 9.7998 8.40001C9.7998 9.89118 11.0086 11.1 12.4998 11.1Z"
              fill="#848B91"
            />
          </svg>
          <span>MY</span>
        </div>
      </div>
      <div
        onClick={() => {
          navigate(`/menu`);
        }}
      >
        <div className={`tab-btn ${current === "menu" ? "active" : ""}`}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 5.5C4 5.22386 4.22386 5 4.5 5H19.5C19.7761 5 20 5.22386 20 5.5C20 5.77614 19.7761 6 19.5 6H4.5C4.22386 6 4 5.77614 4 5.5Z"
              fill="#848B91"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 11.5C4 11.2239 4.22386 11 4.5 11H19.5C19.7761 11 20 11.2239 20 11.5C20 11.7761 19.7761 12 19.5 12H4.5C4.22386 12 4 11.7761 4 11.5Z"
              fill="#848B91"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 17.5C4 17.2239 4.22386 17 4.5 17H19.5C19.7761 17 20 17.2239 20 17.5C20 17.7761 19.7761 18 19.5 18H4.5C4.22386 18 4 17.7761 4 17.5Z"
              fill="#848B91"
            />
          </svg>
          <span>전체메뉴</span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
